import {Component, OnInit, Renderer2} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import * as moment from 'moment';
import {Router, NavigationStart} from '@angular/router';
import {SharedService} from './shared/shared-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  previousUrl: string;

  constructor(private spinner: NgxSpinnerService, private renderer: Renderer2, private router: Router) {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (this.previousUrl) {
            this.renderer.removeClass(document.body, this.previousUrl);
          }
          const currentUrlSlug = event.url.slice(1);
          switch (currentUrlSlug) {
            case 'signin':
            case '':
            case 'emailResetPasswordLink':
            case 'emailSent':
            case 'setPassword': // Not working
            case 'permit-app/home':
            case 'permit-app': {
              this.renderer.addClass(document.body, 'thm-home');
              this.renderer.removeClass(document.body, 'thm-others');
              break;
            }
            default: {
              this.renderer.addClass(document.body, 'thm-others');
              this.renderer.removeClass(document.body, 'thm-home');
              break;
            }
          }
          this.previousUrl = currentUrlSlug;
        }
      });
  }
}
